<template>
    <div class="mr-10">
        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
            {{ snackbar_message }}
        </v-snackbar>

        <div>
            <v-layout column>
                <v-flex xs4 offset-xs8>
                    <v-layout row justify-end>
                        <v-btn rounded color="primary" class="text-capitalize mr-2" to="/organizations/new"
                            v-if="$can('create organizations')">
                            Ajouter
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>

                        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('export organizations')">
                            <export-excel :data="organizations" name="Organisations.xls" :export-fields="org_fields">
                                Exporter
                                <v-icon right>mdi-share-outline</v-icon>
                            </export-excel>
                        </v-btn>

                        <v-btn rounded color="primary" class="text-capitalize mr-2" :disabled="selected.length < 1"
                            @click="validating(selected)">
                            Valider
                            <v-icon right>mdi-check</v-icon>
                        </v-btn>

                    </v-layout>
                </v-flex>
            </v-layout>
        </div>

        <v-layout row wrap class="mt-5 mr-2">
            <v-select v-model="search_department" :items="liste_dep" item-text="name" item-value="id" clearable solo
                label="Département" @change="fetchUtils()" class="ml-2 mr-2"></v-select>

            <v-text-field v-model="search" label="Rechercher une organisation" append-icon="mdi-magnify" solo class="">
            </v-text-field>
        </v-layout>



        <v-data-table v-if="organizations" v-model="selected" :headers="headers" :items="organizations" :loading="loading"
            show-select sort-by="name" loading-text="Loading... Please wait" :search="search" :page.sync="currentPage"
            :server-items-length="orgTotalItems" :items-per-page.sync="rowsPerPageItems" :footer-props="footerProps"
            class="elevation-1 mt-2">
            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="showItem(item.id)" v-if="$can('view organizations')">
                    mdi-eye-outline
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item.id)" v-if="$can('edit organizations')">
                    mdi-pencil-outline
                </v-icon>
                <v-icon small @click="isDeletingOrg(item)" v-if="$can('delete organizations')">
                    mdi-trash-can-outline
                </v-icon>

                <v-icon @click="validating(item)" v-if="$can('validate organizations') && item.validate == false
                    ">
                    mdi-check
                </v-icon>



                <div>

                </div>
            </template>
            <template v-slot:item.user_creator="{ item }">
                    <td v-if="item.user_creator && item.user_creator.profile">
                        {{ item.user_creator.profile.full_name }}
                    </td>
                    <td v-else>
                        {{
                        item.user_creator ? item.user_creator.username : ''
                        }}

                    </td>
                </template>
        </v-data-table>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_deletion" max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text class="text-center">
                        Etes-vous sûr de vouloir supprimer cette organisation ?
                    </v-card-text>

                    <v-card-actions>
                        <v-btn color="orange" rounded @click="dialog_deletion = false">
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" :loading="load" :disabled="load" rounded @click="delOrganization()">
                            Oui
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

        <v-layout justify-center>
            <v-dialog v-model="dialog" persistent hide-overlay max-width="290">
                <v-card>
                    <v-card-title class="headline">{{
                        dialog_title
                        }}</v-card-title>
                    <v-card-text>{{ delete_message }}</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded color="orange" @click="dialog = false">Non</v-btn>
                        <v-btn :loading="loading" :disabled="loading" rounded color="primary"
                            @click="validateItem()">Oui</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
import Permissions from "~/mixins/Permissions";

export default {
    name: "organizations-list",
    mixins: [Permissions],
    data: () => ({
        snackbar: false,
        loading: false,
        load: false,
        snackbar_message: "",
        snackbar_timeout: 5000,
        snackbar_color: "",
        del_org: null,
        del_index: null,
        search: "",
        dialog_edit: false,
        dialog_deletion: false,
        headers: [
            { text: "Organisation", value: "name" },
            { text: "Type", value: "type" },
            { text: "Village", value: "town.name" },
            { text: "Chaine de valeur", value: "chain.name" },
            { text: "Date de création", value: "creation_date" },
            { text: "Ajouter par", value: "user_creator" },
            { text: "Actions", value: "action", sortable: false }
        ],
        org_fields: {
            Organisation: "name",
            Type: "type",
            Village: "town.name",
            "Chaine de valeur": "chain.name",
            "Date de création": "creation_date"
        },
        editedIndex: -1,
        editedItem: {
            name: "",
            type: "",
            pea: "",
            department_id: null,
            value_chain_id: null,
            maillon_id: null
        },
        defaultItem: {
            name: "",
            type: "",
            pea: "",
            department_id: null,
            value_chain_id: null,
            maillon_id: null
        },
        payload: {
            query: {
                page: 1,
                query: 15
            }
        },
        footerProps: {
            "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
            "items-per-page-text": "Lignes par page"
        },
        organizations: [],
        organization_id: null,
        orgTotalItems: null,
        rowsPerPageItems: null,
        currentPage: null,
        delete_message: "",
        dialog_title: "",
        loading: false,
        dialog: false,
        selected: [],
        search_department: null,

    }),
    created() {
        this.organization_id = this.$route.query.organization_id
        this.$checkPermission("view organizations no validate");
    },
    mounted() {
        this.fetchUtils();
    },

    computed: {
        new_org_added: {
            get: function () {
                return this.$route.params.new_org_added;
            },

            set: function (value) {
                this.$route.params.new_org_added = value;
            }
        },
        upd_org_added: {
            get: function () {
                return this.$route.params.upd_org_added;
            },

            set: function (value) {
                this.$route.params.upd_org_added = value;
            }
        },
        org_deleted: {
            get: function () {
                return this.$route.params.org_deleted;
            },

            set: function (value) {
                this.$route.params.org_deleted = value;
            }
        },
        liste_dep() {
            return this.$store.getters.departments.filter(function (departement) {
                return (
                    departement.name === "COLLINES" ||
                    departement.name === "BORGOU" ||
                    departement.name === "DONGA"
                );
            });
        }
    },

    watch: {
        rowsPerPageItems(newVal, oldVal) {
            if (newVal != oldVal) {
                this.payload.query.size = newVal;
                this.fetchUtils();
            }
        },
        currentPage(newVal, oldVal) {
            if (newVal != oldVal) {
                this.payload.query.page = newVal;
                this.fetchUtils();
            }
        },
        search(newVal, oldVal) {
            if (newVal != oldVal) {
                this.payload.query.search = newVal;
                this.fetchUtils();
            }
        }
    },

    methods: {
        async fetchUtils() {
            this.loading = true;
            let uri = `/api/organizations?no_validate=true&include=country,department,municipality,district,town,chain,maillon,userCreator`;
            if (this.search_department) {
                uri = uri + '&department_id=' + this.search_department
            }

            if (this.organization_id) {
                uri = uri + '&organization_id=' + this.organization_id
            }

            await axios
                .get(uri, { params: this.payload.query })
                .then(result => {
                    this.currentPage = result.data.current_page;
                    this.orgTotalItems = result.data.total;
                    this.rowsPerPageItems = parseInt(result.data.per_page);
                    this.organizations = result.data.data;
                    this.loading = false;
                });

            if (this.new_org_added) {
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message =
                    "Nouvelle organisation enregistrée avec succès !";
                this.new_org_added = null;
            } else if (this.upd_org_added) {
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message =
                    "Organisation mise à jour avec succès !";
                this.upd_org_added = null;
            } else if (this.org_deleted) {
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message = "Organisation supprimée avec succès !";
                this.org_deleted = null;
            }
        },

        showItem(id) {
            this.$router.push({
                name: "organizations.show",
                params: { Pid: id }
            });
        },

        editItem(id) {
            this.$router.push({
                name: "organizations.edit",
                params: { Pid: id }
            });
        },

        isDeletingOrg(item) {
            this.del_index = this.organizations.indexOf(item);
            this.dialog_deletion = true;
            this.del_org = item.id;
        },

        delOrganization() {
            if (this.del_org) {
                this.load = true;
                const uri = "/api/organizations/" + this.del_org;
                let objet = this;

                axios
                    .delete(uri)
                    .then(response => {
                        this.fetchUtils();
                        objet.dialog_deletion = false;
                        objet.snackbar = true;
                        objet.snackbar_color = "success";
                        objet.snackbar_message = "Organisation supprimée !";

                        // this.organizations.splice(this.del_index, 1);
                    })
                    .catch(err => {
                        console.log("Organization deletion error ", err);
                    });
                this.load = false;
            }
        },

        validating(item) {
            this.ids = [];
            this.isValidate = true;
            if (Array.isArray(item) && item.length > 0) {
                this.ids = this.selected.map(item => {
                    return item.id;
                });
                this.dialog_title = "Validation";
                this.delete_message =
                    "Etes-vous sûr de vouloir valider ces évènements ?";
                this.dialog = true;
            } else {
                this.ids.push(item.id);
                this.isSingleDelete = true;
                this.dialog_title = "Validation";
                this.delete_message =
                    "Etes-vous sûr de vouloir valider cette organisation ?";
                this.dialog = true;
            }
        },
        async validateItem() {
            this.loading = true;
            const uri = "/api/organization-validate";

            await axios.post(uri, { ids: this.ids });

            this.loading = false;
            this.dialog = false;
            this.snackbar = true;
            this.selected = [];
            this.ids = [];
            if (this.ids.length > 1) {
                this.snackbar_message = "Organisation validés avec succès!";
            } else {
                this.snackbar_message = "Organisation validé avec succès!";
            }
            this.fetchUtils();
        }
    }
};
</script>

<style scoped>
.couleur-orange {
    color: rgb(255, 152, 0);

    font-size: 1.2em;
}

.white-couleur {
    color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/organizations/no-validate.vue